import React from "react";
import "./AboutUs.css";
import organizationStructure from "../../assets/organization-structure.png";
import IconCheck from "@mui/icons-material/CheckCircle";

const AboutUs = () => {
  const ListItem = ({ text }) => {
    return (
      <li className="flex-row align-items-center mb-5">
        {<IconCheck className="mr-5 check-icon" />}
        <span>{text}</span>
      </li>
    );
  };

  return (
    <div className="about app-padding">
      {/* WHO WE ARE */}
      <section className="mt-50">
        <h1>Who We Are</h1>
        <p>
          The Tanzania Financial Sector Computer Emergency Response Team
          (TZ-FinCERT) hosted by the Bank of Tanzania is a focal point for
          handling cyber security issues within the financial sector in the
          country.
        </p>
        <p>
          TZ-FinCERT is a sectorial CERT mandated from TZ-CERT which is
          established under the Electronic and Postal Communications (Computer
          Emergency Response Team) Regulations, 2018.
        </p>
      </section>

      {/* WHAT WE DO */}
      <section className="mt-30">
        <h1 className="app- mb-10">What We Do</h1>
        <ul>
          <ListItem
            text={
              "Receiving and Analyzing Information Security Incident alerts"
            }
          />
          <ListItem
            text={
              "Providing Information Security Incident alerts and warning to constituents "
            }
          />
          <ListItem
            text={
              "Responding to Cyber Security Incidents within the financial sector or other sectoral specific CERTs"
            }
          />
          <ListItem
            text={"Conducting vulnerability discovery and researching"}
          />
          <ListItem text={"Receiving vulnerability Information"} />
          <ListItem
            text={
              "Providing Cyber Security Capacity Building (Security Awareness and Training)"
            }
          />
          <ListItem text={"Conducting Cyber Security drill and exercises"} />
          <ListItem text={"Providing technical advisory and reports"} />
          <ListItem
            text={
              "Cooperate with law enforcement and regulatory agencies investigating cyber-crime or other illegal activities"
            }
          />
          <ListItem
            text={
              "Prepare quarterly reports on the performance of TZ-FinCERT and disseminate the same relevant stakeholders"
            }
          />
        </ul>
      </section>

      {/* ORGANIZATION STRUCTURE */}
      <section className="mt-30">
        <h1 className="app-title">Organization Structure</h1>
        <div className="flex-row justify-content-center p-50">
          <img
            id="organization-structure"
            src={organizationStructure}
            alt="tz-fincert organization structure"
          />
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
